import React from 'react';
import { SupplyClassSection } from './SupplyClassSection';
import { supplyClassesData } from './supplyClassesData';
export const InputsTab = () => {
  return <div className="px-6 pb-6 max-h-[calc(100vh-200px)] overflow-y-auto" data-id="element-62">
      <div className="sticky top-0 bg-white pb-4 z-10 border-b border-gray-200 -mx-6 px-6 pt-4 backdrop-blur-sm rounded-t-lg before:absolute before:inset-0 before:bg-white before:z-[-1] before:rounded-t-lg" data-id="element-63">
        <h2 className="text-lg font-semibold text-gray-900" data-id="element-64">
          Consolidate and Monitor all LOGSTAT reports, GCSS-A data, and JBCP data
        </h2>
        
      </div>
      <div className="space-y-4 mt-3" data-id="element-65">
        {supplyClassesData.map(supplyClass => <SupplyClassSection key={supplyClass.id} supplyClass={supplyClass} data-id="element-66" />)}
      </div>
    </div>;
};